// frontend/src/lib/companiaSesion.ts
// Resolución de la compañía forzada por la sesión para usuarios no-admin.
// Siempre devuelve una entrada válida de COMPANIAS (o null si no se puede resolver).

import { COMPANIAS } from '../components/TopAppBar';

export interface UsuarioSesionCompania {
  scope?: string | null;
  compania_id?: number | string | null;
  compania_nombre?: string | null;
}

/**
 * Compañía de un usuario no-admin, en la nomenclatura del frontend
 * ('Décima Compañía'). Prioriza compania_nombre si coincide exactamente con
 * COMPANIAS; si no, mapea compania_id → COMPANIAS[compania_id - 1].
 * Devuelve null si no hay datos válidos.
 */
export function resolverCompaniaUsuario(user: UsuarioSesionCompania | null | undefined): string | null {
  if (!user) return null;
  const nombre = typeof user.compania_nombre === 'string' ? user.compania_nombre.trim() : '';
  if (nombre && COMPANIAS.includes(nombre)) return nombre;
  const id = Number(user.compania_id);
  if (Number.isInteger(id) && id >= 1 && id <= COMPANIAS.length) return COMPANIAS[id - 1];
  return null;
}

/** Lee auth_user de localStorage y resuelve su compañía si es no-admin. */
export function leerCompaniaSesionGuardada(): { esAdmin: boolean; compania: string | null } | null {
  try {
    const user = JSON.parse(localStorage.getItem('auth_user') || 'null');
    if (!user) return null;
    if (user.scope === 'admin') return { esAdmin: true, compania: null };
    return { esAdmin: false, compania: resolverCompaniaUsuario(user) };
  } catch {
    return null;
  }
}
